import { render, staticRenderFns } from "./AddPolicyModal.vue?vue&type=template&id=2579a96e&scoped=true&"
import script from "./AddPolicyModal.vue?vue&type=script&lang=js&"
export * from "./AddPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPolicyModal.vue?vue&type=style&index=0&id=2579a96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579a96e",
  null
  
)

/* custom blocks */
import block0 from "./AddPolicyModal.vue?vue&type=custom&index=0&blockType=input&class=input%20input--default&%3Avalue=formattedNumberTest&%40input=validateInput"
if (typeof block0 === 'function') block0(component)

export default component.exports